module.exports = "../study/imgs/maps/Kanagawa/S8/WaterEnvironment/Chlave/Kanagawa_Chlave_GFDL_RCP45_Now.png";